import React from 'react';

const Header = () => {
  return (
    <header>
      <h1>Debasish Behera</h1>
      <nav>
        <a href="#about">About</a>
        <a href="#projects">Projects</a>
        <a href="#contact">Contact</a>
      </nav>
    </header>
  );
};

export default Header;
